export const useForegroundNotifications = (): void => {}
